/**
 * Central tab definitions for DashboardPage.
 * Add a new tab here — no changes needed in DashboardPage.
 * scrollable: true = wrap in DashboardScrollContent
 * admin: true = only visible for admin role
 *
 * DevTab and all its dependencies (serviceRegistry, introspector, etc.)
 * are excluded from production builds via import.meta.env.DEV guard.
 * Vite tree-shaking removes the entire DevTab folder in prod.
 */

import { lazy } from 'react';
const AccountTab = lazy(() => import('../AccountTab'));
const AdminTab = lazy(() => import('../AdminTab'));
const DashboardYourData = lazy(() => import('../DashboardYourData'));
const YourNotesTab = lazy(() => import('../YourNotesTab/YourNotesTab'));
const YourSearchTab = lazy(() => import('../YourSearchTab'));
const YourLibraryTab = lazy(() => import('../YourLibraryTab'));
const SettingsTab = lazy(() => import('../SettingsTab/SettingsTab'));
const LogTab = lazy(() => import('../LogTab'));

// DevTab is lazy-loaded and only included in dev builds.
// In production, import.meta.env.DEV is false — Vite statically removes this branch
// and excludes the entire DevTab folder from the bundle.
const DevTab = import.meta.env.DEV
    ? lazy(() => import('../DevTab/DevTab'))
    : null;

const devTabs = import.meta.env.DEV
    ? [{ id: 'dev', label: 'Dev', component: DevTab, scrollable: false, admin: true }]
    : [];

export const DASHBOARD_TABS = [
    { id: 'account',   label: 'Account',        component: AccountTab,        scrollable: true,  admin: false },
    { id: 'yourdata',  label: 'Your Data',      component: DashboardYourData, scrollable: false, admin: false },
    { id: 'yournotes', label: 'Your Notes',     component: YourNotesTab,      scrollable: false, admin: false },
    { id: 'search',    label: 'Search',         component: YourSearchTab,     scrollable: false, admin: false },
    { id: 'library',   label: 'Your Workspace', component: YourLibraryTab,    scrollable: false, admin: false },
    { id: 'settings',  label: 'Settings',       component: SettingsTab,       scrollable: false, admin: false },
    { id: 'admin',     label: 'Admin',          component: AdminTab,          scrollable: true,  admin: true  },
    { id: 'log',       label: 'Log',            component: LogTab,            scrollable: false, admin: true  },
    ...devTabs,
];
